import { render, staticRenderFns } from "./memberReportList.vue?vue&type=template&id=b53b2540&scoped=true&lang=html&"
import script from "./memberReportList.vue?vue&type=script&lang=js&"
export * from "./memberReportList.vue?vue&type=script&lang=js&"
import style0 from "./memberReportList.vue?vue&type=style&index=0&id=b53b2540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b2540",
  null
  
)

export default component.exports